export default "__VITE_ASSET__D2q44P2h__"